export default __webpack_public_path__ + "static/char-v-59-ja-39b8d71a1d76c5f1613311d3938986ba.mp4";